(() => {
  const touchLike = window.innerWidth < 768 || (window.matchMedia && window.matchMedia('(hover: none), (pointer: coarse)').matches);
  if (!touchLike) return;

  if (typeof window.productHoverSlider === 'function') {
    window.productHoverSlider = function () {};
  }
})();
